import { TLD } from "config";

export const getAuthToken = (): string => {
  for (const cookie of document.cookie.split("; ")) {
    const [key, val] = cookie.split("=");
    const decodedKey = decodeURIComponent(key);

    if (decodedKey === "flight_jwt") {
      const decodedVal = decodeURIComponent(val);
      // TODO(arthurio): Remove backward compatible code and always check TLD
      if (decodedVal.includes(":")) {
        const [topLevelDomain, jwt] = decodedVal.split(":");
        if (topLevelDomain === TLD) {
          return jwt;
        }
      } else {
        return decodedVal;
      }
    }
  }
  return "";
};
